module.exports = __webpack_public_path__ + "static/media/PM62.9df38bd5.png";